// @flow
import {
  Container,
  CssBaseline,
  CircularProgress,
  Grid,
} from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { AuthContext } from '../context/auth';
import routes from '../routes';
import ApiResponse from '../model/ApiResponse';
import { doPost as doRawPost } from '../util/api';

type Props = {
  match?: any,
};

const ValidationBack = (props: Props) => {
  const { t } = useTranslation();
  const { match } = props;
  const { user, doPost } = useContext(AuthContext);

  const [redirect, setRedirect] = useState<boolean>(false);

  const loadData = () => {
    if (!!match && match.params && match.params.code) {
      if (!!user) {
        doPost(`/customer/sign-process/${match.params.code}/check-validation`)
          .then((response: ApiResponse) => {
            setRedirect(true);
          });
      } else {
        doRawPost(`/customer/sign-process/${match.params.code}/check-anon-validation`)
          .then((response: ApiResponse) => {
            setRedirect(true);
          });
      }
    }
  };

  useEffect(loadData, []);

  if (!match || !match.params || !match.params.code) {
    return <Redirect to={routes.home}/>;
  }

  if (redirect) {
    return <Redirect to={`${routes.process}/${match.params.code}`}/>;
  }

  return (
    <Container component="main" maxWidth="xl">
      <CssBaseline/>
      <h1>{t('Your validation is processing')}</h1>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <CircularProgress />
      </Grid>
    </Container>
  );
};

export default ValidationBack;
